import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { EN, DA, CS, NL, FI, FR, DE, IT, NB, PT, ES, SV, CY, ZH, PL } from "../languages";

function getLanguageSource(language: string): Record<string, string> {
  switch(language) {
    case "en": return EN;
    case "da": return DA;
    case "zh": return ZH;
    case "cs": return CS;
    case "nl": return NL;
    case "fi": return FI;
    case "fr": return FR;
    case "de": return DE;
    case "it": return IT;
    case "nb": return NB;
    case "pl": return PL;
    case "pt": return PT;
    case "es": return ES;
    case "sv": return SV;
    case "cy": return CY;
    default: return EN;
  }
}

const i18nInstance = i18n.createInstance();

i18nInstance.use(initReactI18next).init({
  lng: "en",
  debug: false,
  fallbackLng: "en",
  resources: {
    en: { translation: EN },
  },
  react: {
    bindI18n: "languageChanged",
    bindI18nStore: "languageChanged",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false,
  },
});

export const changeLanguage = (language: string) => {
  const languageTemp = language.split("-")[0];
  i18nInstance.init({
    lng: languageTemp,
    debug: false,
    fallbackLng: languageTemp,
    resources: {
      [languageTemp || ""]: {
        translation: getLanguageSource(languageTemp),
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "languageChanged",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: true,
    },
  });
};

export default i18nInstance;
